import { useEffect, useState } from "react";
import { X } from "lucide-react";

const KEY = "jaf_cookie_consent_v1";

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setShow(true);
  }, []);

  const accept = () => {
    localStorage.setItem(KEY, "accepted");
    setShow(false);
  };
  const decline = () => {
    localStorage.setItem(KEY, "declined");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-md z-50 rounded-xl shadow-lg p-5"
      style={{
        backgroundColor: "#fff",
        border: "1px solid var(--jaf-border)",
      }}
    >
      <button
        type="button"
        aria-label="Close"
        onClick={decline}
        className="absolute top-3 right-3 text-[color:var(--jaf-text-muted)] hover:text-[color:var(--jaf-text)]"
        data-testid="cookie-close"
      >
        <X size={16} />
      </button>
      <h4 className="font-serif text-lg mb-1">A quick note on cookies</h4>
      <p className="text-sm mb-4" style={{ color: "var(--jaf-text-muted)" }}>
        We use cookies to make JustAirFry warmer for you — for analytics and to remember the recipes you love. By accepting, you agree to our use of cookies.
      </p>
      <div className="flex gap-3">
        <button
          type="button"
          data-testid="cookie-accept"
          onClick={accept}
          className="jaf-btn-primary px-4 py-2 rounded-md text-sm font-medium"
        >
          Accept
        </button>
        <button
          type="button"
          data-testid="cookie-decline"
          onClick={decline}
          className="px-4 py-2 rounded-md text-sm font-medium border"
          style={{
            borderColor: "var(--jaf-border)",
            color: "var(--jaf-text)",
            backgroundColor: "var(--jaf-bg)",
          }}
        >
          Decline
        </button>
      </div>
    </div>
  );
}
